// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-js-components-forms-switch-module__switchText--LKXob {
    margin-right: 0.5rem;
    text-align: right;
}

.src-js-components-forms-switch-module__wrapperText--LYw9J {
    margin-left: 0.125rem;
}

.src-js-components-forms-switch-module__wrapperDiv--KJbpD {
    min-height: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/js/components/forms/switch.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".switchText {\n    margin-right: 0.5rem;\n    text-align: right;\n}\n\n.wrapperText {\n    margin-left: 0.125rem;\n}\n\n.wrapperDiv {\n    min-height: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"switchText": `src-js-components-forms-switch-module__switchText--LKXob`,
	"wrapperText": `src-js-components-forms-switch-module__wrapperText--LYw9J`,
	"wrapperDiv": `src-js-components-forms-switch-module__wrapperDiv--KJbpD`
};
export default ___CSS_LOADER_EXPORT___;
